import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const FranceReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Apostille for France:</h3>
        <p>
          Legalization for France has its own importance in the visa process &
          expansion of the business in France. There are policies of France that
          need documents with the MEA sticker to sanction a visitor to enter
          their country. It is a part of the evidence that signifies the
          trustworthiness of the documents.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille for France:</h3>
        <p>
          The time-span required for Apostille documents for France depends on
          various reasons such as which state the certificate was issued from,
          or the sorts of documents, or the organization you need it from.
          Generally, it will take around a couple of weeks to 2-3 working days
          to accomplish the whole process of France Apostille services in
          Bangalore.
        </p>
      </div>
    </div>
  );
};

export default FranceReqMain;
